import moment from 'moment';
import { DATETIME_FORMAT, SITECORE_ISO_DATE_FORMAT } from 'src/constants';

export const convertToLocale = (date: string): Date | null => (date ? new Date(moment(date).format(DATETIME_FORMAT)) : null);

export const convertToIsoFormat = (date: Date): string => (date ? `${moment(date).utc().format(SITECORE_ISO_DATE_FORMAT)}Z` : '');
